import React, { useState } from "react";
import { Snackbar, Alert as MuiAlert } from "@mui/material";

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const SnackbarAlert = React.forwardRef(({}, ref) => {
  const [snackbarProps, setSnackbarProps] = useState({
    open: false,
    type: "",
    message: "",
  });

  React.useImperativeHandle(ref, () => ({
    isOpenSnack(params) {
      setSnackbarProps({
        open: true,
        type: params.snackType,
        message: params.snackMessage,
      });
    },
  }));

  const handleCloseSnack = () => {
    setSnackbarProps({
      open: false,
      type: "",
      message: "",
    });
  };

  return (
    <Snackbar
      open={snackbarProps.open}
      autoHideDuration={4000}
      onClose={() => handleCloseSnack()}
      anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
    >
      <Alert
        onClose={() => handleCloseSnack()}
        severity={snackbarProps.type}
        sx={{ width: "100%" }}
      >
        {snackbarProps.message}
      </Alert>
    </Snackbar>
  );
});

export default SnackbarAlert;
